import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { redirectMarketingAppPathsToAppOrigin } from './app/core/boot/marketing-host-redirect';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// Auth/admin en milinco.com → milinco.app (OAuth solo autoriza .app). Antes del bootstrap.
if (redirectMarketingAppPathsToAppOrigin()) {
  // Navigation away; skip boot on this host.
} else {
  function resolveSentryEnvironment(): string {
    const host = window.location.hostname;
    if (host.includes('staging')) return 'staging';
    if (host === 'localhost' || host === '127.0.0.1') return 'development';
    return 'production';
  }

  if (environment.production && environment.sentryDsn) {
    Sentry.init({
      dsn: environment.sentryDsn,
      environment: resolveSentryEnvironment(),
      release: `${environment.appVersion}+${environment.buildTag}`,
    });
  }

  bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
}
